import React from 'react';
import { PTSchedulesComponent } from './pt-schedules.component';
import {
  usePTSchedules,
  useCreatePTSchedule,
  useUpdatePTSchedule,
  useDeletePTSchedule,
} from '../../utils/api-hooks/pt-schedule.hook';
import { usePagination } from '../../shared/usePagination';

const PTSchedulesContainer: React.FC = () => {
  const pagination = usePagination();
  const {
    data: { data: schedules = [], total: totalSchedules = 0 } = {},
    isLoading: isLoadingSchedules,
    isFetching: isFetchingSchedules,
  } = usePTSchedules(undefined, undefined, pagination.skip, pagination.take);
  const { mutateAsync: createSchedule } = useCreatePTSchedule();
  const { mutateAsync: updateSchedule } = useUpdatePTSchedule();
  const { mutateAsync: deleteSchedule } = useDeletePTSchedule();

  // 檢查是否在加載數據
  const isLoading = isLoadingSchedules || isFetchingSchedules;

  const handleUpdateSchedule = async (values: {
    id: string;
    note?: string;
  }) => {
    try {
      await updateSchedule(values);
    } catch (error) {
      console.error('Error in handleUpdateSchedule:', error);
    }
  };

  const handleDeleteSchedule = async (id: string) => {
    try {
      await deleteSchedule(id);
    } catch (error) {
      console.error('Error in handleDeleteSchedule:', error);
    }
  };

  return (
    <PTSchedulesComponent
      schedules={schedules}
      isLoading={isLoading}
      onCreateSchedule={createSchedule}
      onUpdateSchedule={handleUpdateSchedule}
      onDeleteSchedule={handleDeleteSchedule}
      pagination={{
        ...pagination,
        total: totalSchedules,
      }}
    />
  );
};

export default PTSchedulesContainer;
